<div class="table-autocomplete">
   <ap-autocomplete [value]="value" [minSearch]="filter.getAutocompleteFilterTemplate().minSearch" [autocomplete]="filter.getAutocompleteFilterTemplate().searchMethod" (clear)="onClear()" (choice)="onSelect($event)" [placeholder]="filter.filterTemplate.label"></ap-autocomplete>
</div>
